export function getApiPayloadMessage(payload, fallback = "") {
  if (!payload || typeof payload !== "object") {
    return fallback;
  }

  const message =
    payload.error ||
    payload.message ||
    payload.msg ||
    payload.errorDescription ||
    payload.result?.errorDescription ||
    payload.result?.message ||
    "";

  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }

  return fallback;
}

export function getApiErrorMessage(error, fallback = "Request failed.") {
  const payloadMessage = getApiPayloadMessage(error?.response?.data);
  if (payloadMessage) return payloadMessage;

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message.trim();
  }

  return fallback;
}
